import { ClientsState } from '../../clients/clients.state'
import { Client, Strategy } from '../../types'

export type Props = {
  availableCptyIds: string[]
  availableDepositInstruments: string[]
  availableFeeTypes: string[]
  availableLoanInstruments: string[]
  client: Client
  isSaveSuccess: boolean
  onSave: () => void
  strategies: Strategy[]
}

export const addMissingStrategies = ({ state }: { state: ClientsState }) => {
  const client = state?.client

  if (!client?.defaultFees) {
    return client
  }

  const existingStrategyFees = client.defaultFees.defaultStrategyFees ?? []
  const existingStrategyIds = existingStrategyFees.map(strategy => strategy.strategyTemplateId)
  const allStrategyIds = state?.strategies?.map?.(strategy => strategy.id) ?? []
  const missingStrategyIds = allStrategyIds.filter(
    strategyId => !existingStrategyIds.includes(strategyId)
  )

  const missingStrategyFees = missingStrategyIds.flatMap(strategyId => {
    if (
      strategyId === 'Delta1' ||
      strategyId === 'ConstantProportionLeverage' ||
      strategyId === 'RiskManaged' ||
      strategyId === 'VolatilityControlLeverage'
    ) {
      return [
        {
          strategyTemplateId: strategyId,
          hasBankGuarantee: false,
          isLeveraged: false,
          fees: []
        }
      ]
    }

    if (strategyId === 'TermProtection' || strategyId === 'ContinuousProtection') {
      return [
        {
          strategyTemplateId: strategyId,
          hasBankGuarantee: false,
          isLeveraged: false,
          fees: []
        },
        {
          strategyTemplateId: strategyId,
          hasBankGuarantee: false,
          isLeveraged: true,
          fees: []
        },
        {
          strategyTemplateId: strategyId,
          hasBankGuarantee: true,
          isLeveraged: false,
          fees: []
        },
        {
          strategyTemplateId: strategyId,
          hasBankGuarantee: true,
          isLeveraged: true,
          fees: []
        }
      ]
    }

    return []
  })

  return {
    ...client,
    defaultFees: {
      ...client.defaultFees,
      defaultStrategyFees: [...existingStrategyFees, ...missingStrategyFees]
    }
  }
}
